import { client } from '../client';

interface Role {
  name: string;
}

interface Language {
  id: string;
  name: string;
  locale: string;
}

interface BasicInfo {
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  preferred_name?: string;
  gender?: string;
  date_of_birth?: string;
  pronouns?: string;
  languages?: Language[];
  gender_identity?: string;
}

interface Address {
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zip_code?: string;
}

interface CareAdvisorProfile {
  biography?: string;
}

export interface HashedUser {
  email: string;
  phone_number: string;
  organizations: Organization[];
  role: Role;
  // DO-3968: basic_info and address are returned by GET /auth/{hash}
  // when the user was created via the CareAdvisor "Add new user" flow,
  // but are absent on other code paths. Marking optional matches
  // runtime reality and is what prevents `CompleteProfile.tsx` from
  // crashing on `basic_info.first_name` when the backend omits them.
  basic_info?: BasicInfo;
  address?: Address;
  care_advisor_profile?: CareAdvisorProfile;
}

export interface Organization {
  id: string;
  name: string;
  is_active: boolean;
  credit_card_required: boolean;
}

export const getUserByHash = async (hash: string): Promise<HashedUser> => {
  const { data } = await client.get<HashedUser>(`/auth/${hash}`);

  return data;
};
